var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { REQUEST_STATUS, WEB_COMPONENT_ACTIONS } from '@/constants';
var initState = {
    config: {
        locale: '',
        productId: '',
        authToken: '',
        realm: '',
    },
    isLoginRequiredModalOpen: false,
    isSaveProjectModalOpen: false,
    addToCartStatus: REQUEST_STATUS.INITIAL,
    isShortcutModalOpen: false,
};
export default function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case WEB_COMPONENT_ACTIONS.SET_DATA: {
            return __assign(__assign({}, state), { config: __assign(__assign({}, state.config), action.payload) });
        }
        case WEB_COMPONENT_ACTIONS.LOGIN_REQUIRED_MODAL: {
            return __assign(__assign({}, state), { isLoginRequiredModalOpen: action.payload });
        }
        case WEB_COMPONENT_ACTIONS.SAVE_PROJECT_MODAL: {
            return __assign(__assign({}, state), { isSaveProjectModalOpen: action.payload });
        }
        case WEB_COMPONENT_ACTIONS.ADD_TO_CART_STATUS: {
            return __assign(__assign({}, state), { addToCartStatus: action.payload });
        }
        case WEB_COMPONENT_ACTIONS.SHORTCUT_MODAL: {
            return __assign(__assign({}, state), { isShortcutModalOpen: action.payload });
        }
        default: {
            return state;
        }
    }
}
